export * from './lib/register-success.component';
